import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const SelectCustom = ({ label, option, placeholder, id, name, value, onChange, onBlur, touched, error, disabled }) => {
    return (
        <div>
            <div className='flex flex-col gap-2 items-start'>
                <p className='col-span-1 max-sm:col-span-1 text-sm'>{label}</p>
                <div className='w-full max-sm:col-span-1 col-span-4'>
                    <Select
                        defaultValue={option[0]}
                        size='large'
                        className='w-full rounded-lg'
                        placeholder={placeholder}
                        id={id}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        options={option}
                        disabled={disabled}
                    />
                    {touched && error ? (
                        <p className="text-xs text-red-500 mb-2 mt-2 ml-2">{error}</p>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

SelectCustom.propTypes = {
    label: PropTypes.string,
    option: PropTypes.array,
    placeholder: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    touched: PropTypes.string,
    error: PropTypes.string
};

export default SelectCustom;